import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const MigrationPreview = () => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const preview = async () => {
    setBusy(true);
    try {
      const r = await api.get("/migrations/tier-preview");
      setData(r.data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Gagal memuat preview");
    } finally { setBusy(false); }
  };

  const apply = async () => {
    if (!window.confirm("Hitung ulang tier & reward semua customer sekarang?")) return;
    setBusy(true);
    try {
      const r = await api.post("/migrations/tier-apply", {});
      toast.success(`${r.data.customers} customer dihitung ulang`);
      setData(null);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Gagal");
    } finally { setBusy(false); }
  };

  return (
    <div className="mt-6 border-t border-black/10 pt-4" data-testid="tier-migration">
      <div className="flex items-center gap-3 flex-wrap">
        <button data-testid="tier-preview-btn" disabled={busy} onClick={preview}
          className="h-9 px-4 rounded-md border border-black/15 text-xs hover:border-lm-red disabled:opacity-50">
          Preview perubahan tier
        </button>
        {data && (
          <button data-testid="tier-apply-btn" disabled={busy} onClick={apply}
            className="h-9 px-4 rounded-md bg-ink text-cream text-xs hover:bg-lm-red disabled:opacity-50">
            Terapkan ke {data.change_count} customer
          </button>
        )}
      </div>
      {data && (
        <div className="mt-3 text-xs">
          <div className="text-ink-soft">
            Basis: <b>{data.basis === "paid" ? "Pembayaran selesai" : "Booking Completed"}</b> ·
            {" "}{data.customers} customer diperiksa · {data.change_count} akan berubah tier
          </div>
          <div className="mt-2 max-h-52 overflow-y-auto divide-y divide-black/5">
            {data.changes.map((c) => (
              <div key={c.customer_id} className="py-1.5 flex flex-wrap gap-x-3" data-testid={`tier-change-${c.customer_id}`}>
                <span className="font-medium">{c.name}</span>
                <span className="text-ink-soft">{c.whatsapp}</span>
                <span className="text-ink-soft">{c.completed_rentals} sewa dihitung</span>
                <span>{c.from_tier || "—"} → <b>{c.to_tier}</b> ({c.to_discount}%)</span>
              </div>
            ))}
            {data.change_count === 0 && <div className="py-2 text-ink-soft">Tidak ada perubahan tier.</div>}
          </div>
        </div>
      )}
    </div>
  );
};
